<template>
	<v-card>
		<v-card-title class="d-flex align-center">
			<translate>Info</translate>
			<v-spacer />
			<v-btn
				v-can="'page.create'"
				color="primary"
				variant="flat"
				prepend-icon="$plus"
				@click="goToCreate"
			>
				<translate>Add New Pages</translate>
			</v-btn>
		</v-card-title>
		<v-card-subtitle>
			<translate>
				Creating or editing pages uses the same interface.  A page has the following attributes:
			</translate>
		</v-card-subtitle>
		<v-card-text>
			<v-list lines="one">
				<v-list-item>
					<strong>
						<translate>Parent Page</translate>:
					</strong>
					<translate>The page above it in the page tree and before it in the page's URL</translate>
				</v-list-item>
				<v-list-item>
					<strong>
						<translate>Template Language</translate>:
					</strong>
					<translate>The language for which this page will be shown</translate>
				</v-list-item>
				<v-list-item>
					<strong>
						<translate>Title</translate>:
					</strong>
					<translate>What will be shown at the top of the page and in the navigation buttons</translate>
				</v-list-item>
				<v-list-item>
					<strong>
						<translate>Shortname</translate>:
					</strong>
					<translate>The value used in the URL path and to identify this page</translate>
				</v-list-item>
				<v-list-item>
					<strong>
						<translate>Published</translate>:
					</strong>
					<translate>Whether users can see this page</translate>
				</v-list-item>
				<v-list-item>
					<strong>
						<translate>Ordering Priority Strength</translate>:
					</strong>
					<translate>All pages will be sorted on this value.  A higher value will be more likely to show up first when compared against other pages.  Default 0.</translate>
				</v-list-item>
				<v-list-item>
					<strong>
						<translate>Text</translate>:
					</strong>
					<translate>This is a smarty template.  Generally pages won't have smarty variables available other than the content page itself available as `$this`. If you aren't a developer, it's recommended you stick to `html`</translate>
				</v-list-item>
			</v-list>
			<p>
				<translate>When you create content pages there must be a version of the page for every supported language or users will get `404` errors when trying to access the page in a language for which we don't have a template.</translate>
			</p>
			<p>
				<translate>Translation strings are available using the standard smarty syntax of {_ \'Translated string\'}. This might be useful for example when trying to dynamically pluralize and gets it's translation the same way as the language is selected for which page to show</translate>
			</p>
		</v-card-text>
	</v-card>
</template>

<script>

export default {
	name: 'PagesOverviewInfoCard',

	methods: {
		/**
		 * Sets location to the page creation route
		 *
		 * @returns {void}
		 */
		goToCreate () {
			window.location.href = '/bo/pages/create';
		}
	}
};
</script>
